<!--
  ChangelogEmptyState.vue
  
  Empty state displayed when no changelog entries are available.
  
  @component
-->
<template>
  <div class="text-center py-12">
    <!-- Empty Icon -->
    <div class="text-charcoal-400 mb-2">
      <svg class="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
    </div>

    <!-- Empty Message -->
    <p class="text-charcoal-300">No version history available yet.</p>
  </div>
</template>

<script setup lang="ts">
// No props or logic needed - simple empty state
</script>
